"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionSection = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_addons_css_transition_group_1 = __importDefault(require("react-addons-css-transition-group"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var AccordionSection = function (props) {
    var isOpen = props.isOpen, id = props.id, children = props.children, handleOnClick = props.handleOnClick;
    var onClick = function () {
        handleOnClick(id);
    };
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)({
            "accordion-section": true,
            "accordion-section--closed": !isOpen,
            "accordion-section--open": isOpen,
        }) },
        react_1.default.createElement("div", { className: "accordion-section__label-container", onClick: onClick },
            react_1.default.createElement("div", { className: (0, classnames_1.default)({
                    "accordion-section__label-icon": true,
                    "accordion-section__label-icon--open": isOpen,
                }) },
                react_1.default.createElement(icons_1.ChevronDown, null)),
            react_1.default.createElement("div", { className: "accordion-section__label" }, children[0])),
        react_1.default.createElement(react_addons_css_transition_group_1.default, { transitionName: "fade", transitionEnterTimeout: 200, transitionLeaveTimeout: 200, component: react_1.default.Fragment }, isOpen && react_1.default.createElement("div", { className: "accordion-section__content" }, children[1])),
        react_1.default.createElement("hr", { className: "accordion-section__hr" })));
};
exports.AccordionSection = AccordionSection;
